/**
 * This file was auto-generated by openapi-typescript.
 * Do not make direct changes to the file.
 */

export interface paths {
  "/api/v2": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Root */
    get: operations["ApiV2Root"];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/v2/health": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Health */
    get: operations["ApiV2HealthHealth"];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/v2/ai-chat/feedback": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** CreateOrUpdateFeedback */
    post: operations["ApiV2AiChatFeedbackCreateOrUpdateFeedback"];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/v2/ai-chat/admin/feedback": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** AdminFeedback */
    get: operations["ApiV2AiChatAdminFeedbackAdminFeedback"];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/v2/ppa/direct-delivery/contracts": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** GetDirectDeliveryContracts */
    get: operations["ApiV2PpaDirectDeliveryContractsGetDirectDeliveryContracts"];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/v2/ppa/direct-delivery/invoices": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** DirectDeliveryInvoices */
    get: operations["ApiV2PpaDirectDeliveryInvoicesDirectDeliveryInvoices"];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/v2/ppa/direct-delivery/invoice": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Return a PDF of a direct delivery invoice */
    get: operations["ApiV2PpaDirectDeliveryInvoiceGetDirectDeliveryInvoicePdf"];
    put?: never;
    /** create a direct delivery invoice */
    post: operations["ApiV2PpaDirectDeliveryInvoiceGenerateDirectDeliveryInvoice"];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/v2/ppa/direct-delivery/invoice/draft": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Generate a draft PDF of a direct delivery invoice */
    get: operations["ApiV2PpaDirectDeliveryInvoiceDraftGenerateDirectDeliveryInvoiceDraft"];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/v2/ppa/direct-delivery/invoice/void": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** VoidDirectDeliveryInvoice */
    post: operations["ApiV2PpaDirectDeliveryInvoiceVoidVoidDirectDeliveryInvoice"];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/v2/ppa/direct-delivery/invoice/send": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** SendDirectDeliveryInvoice */
    post: operations["ApiV2PpaDirectDeliveryInvoiceSendSendDirectDeliveryInvoice"];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/v2/ppa/invoice-number-ranges": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** ListInvoiceNumberRanges */
    get: operations["ApiV2PpaInvoiceNumberRangesListInvoiceNumberRanges"];
    put?: never;
    /** CreateInvoiceNumberRange */
    post: operations["ApiV2PpaInvoiceNumberRangesCreateInvoiceNumberRange"];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/v2/ppa/invoice-number-ranges/suppliers": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** ListAllSuppliers */
    get: operations["ApiV2PpaInvoiceNumberRangesSuppliersListAllSuppliers"];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/v2/ppa/invoice-number-ranges/{range_id}": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** GetInvoiceNumberRange */
    get: operations["ApiV2PpaInvoiceNumberRangesRangeIdGetInvoiceNumberRange"];
    put?: never;
    post?: never;
    /** DeleteInvoiceNumberRange */
    delete: operations["ApiV2PpaInvoiceNumberRangesRangeIdDeleteInvoiceNumberRange"];
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/v2/ppa/direct-delivery/invoices/drift-detection": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** GetInvoiceDrifts */
    get: operations["ApiV2PpaDirectDeliveryInvoicesDriftDetectionGetInvoiceDrifts"];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/v2/ne-email/webhooks/lettermint": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Lettermint */
    post: operations["ApiV2NeEmailWebhooksLettermintLettermint"];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/v2/docs/openapi.json": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Handler */
    get: operations["ApiV2DocsOpenapiJsonHandler"];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/v2/docs": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Handler */
    get: operations["ApiV2DocsHandler"];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/v2/docs/{path}": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** HandleSchemaPathNotFound */
    get: operations["ApiV2DocsPathHandleSchemaPathNotFound"];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
}
export type webhooks = Record<string, never>;
export interface components {
  schemas: {
    /** AdminFeedbackMessageFeedbackResponseBody */
    AdminFeedbackMessageFeedbackResponseBody: {
      comment?: string | null;
      conversation?: unknown[] | null;
      /** Format: uuid */
      id?: string;
      message_id: string;
      user_id: number;
      rating: components["schemas"]["Rating"];
      /** Format: date-time */
      created_at?: string;
      /** Format: date-time */
      updated_at?: string;
    };
    /** Company */
    Company: {
      /** Format: uuid */
      id: string;
      name: string;
    };
    /** ContractCircle */
    ContractCircle: {
      id: number;
      name: string | null;
    };
    /**
     * ContractStatus
     * @enum {string}
     */
    ContractStatus: ContractStatus;
    /** ConversationEntry */
    ConversationEntry: {
      id: string;
      /** @enum {string} */
      role: ConversationEntryRole;
      text: string;
      tools: components["schemas"]["ToolEntry"][];
    };
    /** CreateOrUpdateFeedbackMessageFeedbackResponseBody */
    CreateOrUpdateFeedbackMessageFeedbackResponseBody: {
      comment?: string | null;
      conversation?: unknown[] | null;
      /** Format: uuid */
      id?: string;
      message_id: string;
      user_id: number;
      rating: components["schemas"]["Rating"];
      /** Format: date-time */
      created_at?: string;
      /** Format: date-time */
      updated_at?: string;
    };
    /** DirectDeliveryContract */
    DirectDeliveryContract: {
      id: number;
      name: string;
      contract_file_link: string;
      contract_circle: components["schemas"]["ContractCircle"];
      status: components["schemas"]["ContractStatus"];
      confirmed_termination_date: string | null;
      /** Format: date */
      start_date: string;
      /** Format: date */
      next_end_date: string;
      next_termination_deadline: string | null;
      supplier: components["schemas"]["Company"];
      generation_sites: string[];
      service_recipients: components["schemas"]["Company"][];
      consumption_sites: string[];
    };
    /** FeedbackCreateRequest */
    FeedbackCreateRequest: {
      message_id: string;
      rating: components["schemas"]["Rating"];
      comment?: string | null;
      conversation?: components["schemas"]["ConversationEntry"][] | null;
    };
    /** GetInvoiceNumberRangePPAInvoiceNumberRangeResponseBody */
    GetInvoiceNumberRangePPAInvoiceNumberRangeResponseBody: {
      /** Format: uuid */
      id?: string;
      /** Format: uuid */
      supplier_id: string;
      format: string;
      counter_start_offset: number;
      counter_reset_interval?:
        components["schemas"]["InvoiceCounterInterval"] | null;
      /** Format: date */
      valid_from: string;
    };
    /** Invoice */
    Invoice: {
      unique_identifier: string;
      billing_period: components["schemas"]["InvoiceBillingPeriod"];
      invoice_type: components["schemas"]["InvoiceType"];
      seller_name: string;
      seller_invoice_receiving_emails: string[];
      buyer_name: string;
      filename: string;
      generation_market_location_numbers: string[];
      consumption_market_location_numbers: string[];
      contract_id: number;
      /** Format: uuid */
      service_recipient_id: string;
      state: components["schemas"]["InvoiceState"];
      delivered_on: string | null;
      email_delivery_state:
        components["schemas"]["InvoiceEmailDeliveryState"] | null;
      invoice_number: string | null;
      invoice_creation_date: string | null;
    };
    /** InvoiceBillingPeriod */
    InvoiceBillingPeriod: {
      /** Format: date */
      start: string;
      /** Format: date */
      end: string;
    };
    /**
     * InvoiceCounterInterval
     * @default yearly
     * @enum {string}
     */
    InvoiceCounterInterval: InvoiceCounterInterval;
    /** InvoiceDriftDetails */
    InvoiceDriftDetails: {
      invoice_id: string;
      identity_key: string;
      amount_due_change_is_relevant: boolean;
      previous_amount_due: string;
      new_amount_due: string;
      amount_due_difference: string;
      has_kwh_amount_change: boolean;
      has_price_amount_change: boolean;
      has_line_items_added_or_removed: boolean;
    };
    /**
     * InvoiceEmailDeliveryState
     * @enum {string}
     */
    InvoiceEmailDeliveryState: InvoiceEmailDeliveryState;
    /** InvoiceRequestParams */
    InvoiceRequestParams: {
      unique_identifier: string;
    };
    /**
     * InvoiceState
     * @enum {string}
     */
    InvoiceState: InvoiceState;
    /**
     * InvoiceType
     * @enum {string}
     */
    InvoiceType: InvoiceType;
    /** ListInvoiceNumberRangesPPAInvoiceNumberRangeResponseBody */
    ListInvoiceNumberRangesPPAInvoiceNumberRangeResponseBody: {
      /** Format: uuid */
      id?: string;
      /** Format: uuid */
      supplier_id: string;
      format: string;
      counter_start_offset: number;
      counter_reset_interval?:
        components["schemas"]["InvoiceCounterInterval"] | null;
      /** Format: date */
      valid_from: string;
    };
    /** PPAInvoiceNumberRange */
    PPAInvoiceNumberRange: {
      created_at?: unknown;
      updated_at?: unknown;
      id?: unknown;
      invoice_numbers?: unknown;
      supplier_id: unknown;
      format: unknown;
      counter_start_offset: unknown;
      counter_reset_interval: unknown;
      valid_from: unknown;
    };
    /** PPAInvoiceNumberRangeCreateRequest */
    PPAInvoiceNumberRangeCreateRequest: {
      /** Format: uuid */
      supplier_id: string;
      format: string;
      /** Format: date */
      valid_from: string;
      /** @default 0 */
      counter_start_offset: number;
      counter_reset_interval?: components["schemas"]["InvoiceCounterInterval"];
    };
    /**
     * Rating
     * @enum {string}
     */
    Rating: Rating;
    /** SendInvoiceRequestParams */
    SendInvoiceRequestParams: {
      unique_identifier: string;
    };
    /** Supplier */
    Supplier: {
      /** Format: uuid */
      id: string;
      name: string;
    };
    /** ToolEntry */
    ToolEntry: {
      name: string;
      output?: unknown;
      /** @default false */
      failed: boolean;
    };
    /** VoidInvoiceRequestParams */
    VoidInvoiceRequestParams: {
      unique_identifier: string;
    };
  };
  responses: never;
  parameters: never;
  requestBodies: never;
  headers: never;
  pathItems: never;
}
export type $defs = Record<string, never>;
export interface operations {
  ApiV2Root: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Request fulfilled, document follows */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": {
            [key: string]: string;
          };
        };
      };
    };
  };
  ApiV2HealthHealth: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Request fulfilled, document follows */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": {
            [key: string]: string;
          };
        };
      };
    };
  };
  ApiV2AiChatFeedbackCreateOrUpdateFeedback: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        "application/json": components["schemas"]["FeedbackCreateRequest"];
      };
    };
    responses: {
      /** @description Request fulfilled, document follows */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["CreateOrUpdateFeedbackMessageFeedbackResponseBody"];
        };
      };
      /** @description Bad request syntax or unsupported method */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": {
            status_code: number;
            detail: string;
            extra?:
              | null
              | {
                  [key: string]: unknown;
                }
              | unknown[];
          };
        };
      };
    };
  };
  ApiV2AiChatAdminFeedbackAdminFeedback: {
    parameters: {
      query?: {
        days?: number;
        rating?: PathsApiV2AiChatAdminFeedbackGetParametersQueryRating;
        limit?: number;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Request fulfilled, document follows */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["AdminFeedbackMessageFeedbackResponseBody"][];
        };
      };
      /** @description Bad request syntax or unsupported method */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": {
            status_code: number;
            detail: string;
            extra?:
              | null
              | {
                  [key: string]: unknown;
                }
              | unknown[];
          };
        };
      };
    };
  };
  ApiV2PpaDirectDeliveryContractsGetDirectDeliveryContracts: {
    parameters: {
      query?: {
        start?: string | null;
        end?: string | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Request fulfilled, document follows */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["DirectDeliveryContract"][];
        };
      };
      /** @description Bad request syntax or unsupported method */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": {
            status_code: number;
            detail: string;
            extra?:
              | null
              | {
                  [key: string]: unknown;
                }
              | unknown[];
          };
        };
      };
    };
  };
  ApiV2PpaDirectDeliveryInvoicesDirectDeliveryInvoices: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Request fulfilled, document follows */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["Invoice"][];
        };
      };
    };
  };
  ApiV2PpaDirectDeliveryInvoiceGetDirectDeliveryInvoicePdf: {
    parameters: {
      query: {
        unique_identifier: string;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description PDF file */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": string;
        };
      };
      /** @description Bad request syntax or unsupported method */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": {
            status_code: number;
            detail: string;
            extra?:
              | null
              | {
                  [key: string]: unknown;
                }
              | unknown[];
          };
        };
      };
    };
  };
  ApiV2PpaDirectDeliveryInvoiceGenerateDirectDeliveryInvoice: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        "application/json": components["schemas"]["InvoiceRequestParams"];
      };
    };
    responses: {
      /** @description Status of the invoice generation */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Bad request syntax or unsupported method */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": {
            status_code: number;
            detail: string;
            extra?:
              | null
              | {
                  [key: string]: unknown;
                }
              | unknown[];
          };
        };
      };
    };
  };
  ApiV2PpaDirectDeliveryInvoiceDraftGenerateDirectDeliveryInvoiceDraft: {
    parameters: {
      query: {
        unique_identifier: string;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description PDF file */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": string;
        };
      };
      /** @description Bad request syntax or unsupported method */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": {
            status_code: number;
            detail: string;
            extra?:
              | null
              | {
                  [key: string]: unknown;
                }
              | unknown[];
          };
        };
      };
    };
  };
  ApiV2PpaDirectDeliveryInvoiceVoidVoidDirectDeliveryInvoice: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        "application/json": components["schemas"]["VoidInvoiceRequestParams"];
      };
    };
    responses: {
      /** @description Status of the invoice voiding operation */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Bad request syntax or unsupported method */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": {
            status_code: number;
            detail: string;
            extra?:
              | null
              | {
                  [key: string]: unknown;
                }
              | unknown[];
          };
        };
      };
    };
  };
  ApiV2PpaDirectDeliveryInvoiceSendSendDirectDeliveryInvoice: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        "application/json": components["schemas"]["SendInvoiceRequestParams"];
      };
    };
    responses: {
      /** @description Status of the invoice sending operation */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Bad request syntax or unsupported method */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": {
            status_code: number;
            detail: string;
            extra?:
              | null
              | {
                  [key: string]: unknown;
                }
              | unknown[];
          };
        };
      };
    };
  };
  ApiV2PpaInvoiceNumberRangesListInvoiceNumberRanges: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Request fulfilled, document follows */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ListInvoiceNumberRangesPPAInvoiceNumberRangeResponseBody"][];
        };
      };
    };
  };
  ApiV2PpaInvoiceNumberRangesCreateInvoiceNumberRange: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        "application/json": components["schemas"]["PPAInvoiceNumberRangeCreateRequest"];
      };
    };
    responses: {
      /** @description Document created, URL follows */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["PPAInvoiceNumberRange"];
        };
      };
      /** @description Bad request syntax or unsupported method */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": {
            status_code: number;
            detail: string;
            extra?:
              | null
              | {
                  [key: string]: unknown;
                }
              | unknown[];
          };
        };
      };
    };
  };
  ApiV2PpaInvoiceNumberRangesSuppliersListAllSuppliers: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Request fulfilled, document follows */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["Supplier"][];
        };
      };
    };
  };
  ApiV2PpaInvoiceNumberRangesRangeIdGetInvoiceNumberRange: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        range_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Request fulfilled, document follows */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json":
            | components["schemas"]["GetInvoiceNumberRangePPAInvoiceNumberRangeResponseBody"]
            | null;
        };
      };
      /** @description Bad request syntax or unsupported method */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": {
            status_code: number;
            detail: string;
            extra?:
              | null
              | {
                  [key: string]: unknown;
                }
              | unknown[];
          };
        };
      };
    };
  };
  ApiV2PpaInvoiceNumberRangesRangeIdDeleteInvoiceNumberRange: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        range_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Request fulfilled, nothing follows */
      204: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Bad request syntax or unsupported method */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": {
            status_code: number;
            detail: string;
            extra?:
              | null
              | {
                  [key: string]: unknown;
                }
              | unknown[];
          };
        };
      };
    };
  };
  ApiV2PpaDirectDeliveryInvoicesDriftDetectionGetInvoiceDrifts: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Request fulfilled, document follows */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["InvoiceDriftDetails"][];
        };
      };
    };
  };
  ApiV2NeEmailWebhooksLettermintLettermint: {
    parameters: {
      query?: never;
      header?: {
        "X-Lettermint-Signature"?: string;
      };
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Document created, URL follows */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Bad request syntax or unsupported method */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": {
            status_code: number;
            detail: string;
            extra?:
              | null
              | {
                  [key: string]: unknown;
                }
              | unknown[];
          };
        };
      };
    };
  };
  ApiV2DocsOpenapiJsonHandler: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Request fulfilled, document follows */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/vnd.oai.openapi+json": string;
        };
      };
    };
  };
  ApiV2DocsHandler: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Request fulfilled, document follows */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "text/html": string;
        };
      };
    };
  };
  ApiV2DocsPathHandleSchemaPathNotFound: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        path: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Request fulfilled, document follows */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "text/html": unknown;
        };
      };
      /** @description Bad request syntax or unsupported method */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": {
            status_code: number;
            detail: string;
            extra?:
              | null
              | {
                  [key: string]: unknown;
                }
              | unknown[];
          };
        };
      };
    };
  };
}
export enum PathsApiV2AiChatAdminFeedbackGetParametersQueryRating {
  up = "up",
  down = "down",
  all = "all"
}
export enum ContractStatus {
  upcoming = "upcoming",
  active = "active",
  expired = "expired",
  terminated = "terminated"
}
export enum ConversationEntryRole {
  user = "user",
  assistant = "assistant"
}
export enum InvoiceCounterInterval {
  monthly = "monthly",
  yearly = "yearly"
}
export enum InvoiceEmailDeliveryState {
  dispatched = "dispatched",
  created = "created",
  sent = "sent",
  delivered = "delivered",
  hard_bounced = "hard_bounced",
  soft_bounced = "soft_bounced",
  spam_complaint = "spam_complaint",
  failed = "failed",
  suppressed = "suppressed",
  policy_rejected = "policy_rejected"
}
export enum InvoiceState {
  ready = "ready",
  delivered = "delivered",
  corrected = "corrected",
  sent = "sent"
}
export enum InvoiceType {
  Invoice = "Invoice",
  Draft = "Draft",
  Correction = "Correction"
}
export enum Rating {
  up = "up",
  down = "down"
}
